export const typo = {
	font: 'Nunito',
	defaultFontSize: '0.875rem'
};
